import React from 'react';

export default function Faq() {
    return (
        <div className="mt-9 w-full bg-gray-900 rounded-2xl pt-8 pl-7 pb-6">
            
            <div className="mb-7 pl-16">
                <div className="font-bold text-sm text-gray-400">Популярные вопросы</div>
            </div>

            <div className="whitespace-nowrap font-bold space-y-2 h-96 overflow-y-auto scrollbar pr-2">

                <div className="border-l-2 border-pink pl-10">
                    <div className="bg-secondaryBlack rounded-xl py-4 px-5">
                        <div className="font-bold">Проблемы с аккаунтом</div>
                    </div>
                </div>

                <div className="border-l-2 border-pink pl-10">
                    <div className="bg-secondaryBlack rounded-xl py-4 px-5">
                        <div className="font-bold">Проблемы с аккаунтом</div>
                    </div>
                </div>

                <div className="border-l-2 border-pink pl-10">
                    <div className="bg-secondaryBlack rounded-xl py-4 px-5">
                        <div className="font-bold">Проблемы с аккаунтом</div>
                    </div>
                </div>

                <div className="border-l-2 border-pink pl-10">
                    <div className="bg-secondaryBlack rounded-xl py-4 px-5">
                        <div className="font-bold">Проблемы с аккаунтом</div>
                    </div>
                </div>

                <div className="border-l-2 border-pink pl-10">
                    <div className="bg-secondaryBlack rounded-xl py-4 px-5">
                        <div className="font-bold">Проблемы с аккаунтом</div>
                    </div>
                </div>

                <div className="border-l-2 border-pink pl-10">
                    <div className="bg-secondaryBlack rounded-xl py-4 px-5">
                        <div className="font-bold">Проблемы с аккаунтом</div>
                    </div>
                </div>

                <div className="border-l-2 border-pink pl-10">
                    <div className="bg-secondaryBlack rounded-xl py-4 px-5">
                        <div className="font-bold">Проблемы с аккаунтом</div>
                    </div>
                </div>
            </div>
        </div>
    );
};